import { RESET_STATES } from '../types'

export const doResetStates = () => {
  return {
    type: RESET_STATES,
  }
}
